import searchSuggestionData from './integrationSearchSuggestion';

const searchField = document.getElementById('search-field');
const closeBtn = document.getElementById('close-btn');
const searchResultInner = document.querySelector('.search-result');
const integrationCardList = document.querySelector('.integration-card-list');
const viewMoreBtn = document.querySelector('#viewMoreIntegrations');
const noResultsFoundContainer = document.querySelector('.no-results');
const categoryHeading = document.getElementById('category-heading');

const debounce = (func, delay) => {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

function searchIntegrations() {
  // Get the search value from the search field and trim it
  const searchValue = searchField.value.trim();

  // Filter the integrationData based on the search value,
  // Return empty array if no integration matches the search value
  const filteredResults = searchValue.length > 0
    ? searchSuggestionData.filter(({ integration }) => integration.toLowerCase()
      .includes(searchValue.toLowerCase()))
    : [];

  // Generate the list of suggestions for the filtered integrations
  // If the integration has a link, make the card hyperlink, else make it static
  const suggestionResultList = filteredResults
    .map(({
      link, logoWidth, logoHeight, logo, integration, description,
    }) => (link
      ? `
          <li class="card">
            <a href="${link}" class="card-link">
              <figure class="integration-logo text-center">
                <svg width="${logoWidth}" height="${logoHeight}">
                  <use xlink:href="#${logo}"></use>
                </svg>
              </figure>
              <div>
                <h6>${integration}</h6>
                <p class="sm-text">${description}</p>
              </div>
            </a>
          </li>`
      : `
          <li class="card">
            <div class="card-link">
              <figure class="integration-logo text-center">
                <svg width="${logoWidth}" height="${logoHeight}">
                  <use xlink:href="#${logo}"></use>
                </svg>
              </figure>
              <div>
                <h6>${integration}</h6>
                <p class="sm-text">${description}</p>
              </div>
            </div>
          </li>`))
    .join('');

  // Toggle the 'hide' class on the no results container based on filtered results and
  // search value length
  if (filteredResults.length === 0 && searchValue.length > 0) {
    noResultsFoundContainer.classList.remove('hide');
  } else {
    noResultsFoundContainer.classList.add('hide');
  }

  // Display the suggestion result list
  searchResultInner.innerHTML = suggestionResultList;
}

searchField.addEventListener('input', debounce((event) => {
  const inputVal = event.target.value.trim();

  // Toggle the 'invalid' class on the search field based on the input length
  event.target.classList.toggle('invalid', inputVal.length === 0);

  searchIntegrations();

  integrationCardList.classList.add('hide'); // hide the card list
  viewMoreBtn.classList.add('hide'); // hide the view more button
  closeBtn.classList.toggle('hide', event.target.value === ''); // show the close icon if the input is not empty

  // if the input value is empty, then show the card list and view more button - default state
  if (inputVal.length === 0) {
    viewMoreBtn.classList.add('hide'); // hide the view more button
    integrationCardList.classList.remove('hide');
  }
}, 250));

// Remove the invalid class if the input if focused again
searchField.addEventListener('focus', () => {
  searchField.classList.remove('invalid');
});

// Toggle the 'invalid' class on the search field based on the input length
// when click outside the input field
searchField.addEventListener('blur', (event) => {
  const inputVal = event.target.value.trim();
  event.target.classList.toggle('invalid', inputVal.length === 0);
});

closeBtn.addEventListener('click', () => {
  searchField.value = ''; // clear the input field
  closeBtn.classList.add('hide'); // hide the close icon
  noResultsFoundContainer.classList.add('hide'); // hide the no result container
  if (categoryHeading && categoryHeading.innerText.includes('All integrations')) {
    viewMoreBtn.classList.remove('hide'); // show the view more button
  }
  integrationCardList.classList.remove('hide'); // show the cards list
  searchResultInner.innerHTML = ''; // clear the search results
});
